<template>
  <div>
    <v-btn
      class="mt-3"
      elevation="0"
      small
      light
      color="transparent"
      @click="goBack"
    >
      <v-icon
        size="25"
        color="#000"
      >
        mdi mdi-chevron-left
      </v-icon>Back
    </v-btn>
    <v-card
      color="transparent"
      class="card-style"
      elevation="0"
    >
      <v-expansion-panels
        v-model="panel"
        accordion
        light
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon
              size="24"
              class="v-icon-style"
            >
              mdi-chart-box-outline
            </v-icon>

            <span class="title-header-style"> {{ jobDetails.name }} </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p class="title-text-style">
              Project:
              <font
                v-if="jobDetails.project && jobDetails.project.name"
                class="value-text-style"
              >
                {{ jobDetails.project.name }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Assigned To:
              <font
                v-if="jobDetails.assigned_to_name"
                class="value-text-style"
              >
                {{ jobDetails.assigned_to_name }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Address:
              <font
                v-if="
                  jobDetails.project &&
                    jobDetails.project.address && jobDetails.project.address.city && jobDetails.project.address.line1
                "
                class="value-text-style"
              >
                {{ jobDetails.project.address.city }},
                {{ jobDetails.project.address.line1 }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Description:
              <font
                v-if="jobDetails.description !== null"
                class="value-text-style"
              >
                {{ jobDetails.description }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Planned start:
              <font
                v-if="jobDetails.planned_start_date !== null"
                class="value-text-style"
              >
                {{ jobDetails.planned_start_date | convertToLocal }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Planned end:
              <font
                v-if="jobDetails.planned_end_date !== null"
                class="value-text-style"
              >
                {{ jobDetails.planned_end_date | convertToLocal }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Actual start:
              <font
                v-if="jobDetails.actual_start_date !== null"
                class="value-text-style"
              >
                {{ jobDetails.actual_start_date | convertToLocal }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Actual end:
              <font
                v-if="jobDetails.actual_end_date !== null"
                class="value-text-style"
              >
                {{ jobDetails.actual_end_date | convertToLocal }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p
              v-if="isSiteManager"
              class="title-text-style"
            >
              Amount:
              <font
                v-if="jobDetails.amount !== null"
                class="amount-text-style"
              >
                AUD {{ jobDetails.amount }}
              </font>
              <font
                v-else
                class="amount-text-style"
              >
                AUD 0.00
              </font>
            </p>
            <p class="title-text-style">
              <v-menu
                offset-y
                :close-on-content-click="true"
                :nudge-width="0"
                content-class="status-menu"
                attach
              >
                <template #activator="{ on, attrs }">
                  <!-- Stop propagation so card click won't trigger -->
                  <div
                    class="status-activator"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop
                  >
                    Status:
                    <v-chip
                      small
                      :color="statusColor(getStatusObject(jobDetails).id)"
                      dark
                      label
                      class="ma-0"
                    >
                      <font color="#fff">
                        {{ getStatusObject(jobDetails).title }}
                        <v-icon
                          small
                          class="status-chevron"
                        >
                          mdi-menu-down
                        </v-icon>
                      </font>
                    </v-chip>
                  </div>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="s in statusList"
                    :key="s.id"
                    @click="changeStatus(jobDetails, s)"
                  >
                    <v-list-item-content class="pt-0">
                      <v-chip
                        small
                        :color="statusColor(s.id)"
                        light
                        label
                        class="ma-0"
                      >
                        <font color="#fff">
                          {{ s.title }}
                        </font>
                      </v-chip>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </p>
            <p class="title-text-style">
              Priority:
              <v-chip
                rounded
                :color="getPriorityColor(jobDetails.priority)"
                small
                outlined
                class="chip-style"
                style="margin-left: 10px"
              >
                {{ jobDetails.priority }}
              </v-chip>
            </p>
            <v-row>
              <v-col class="pr-1">
                <v-slider
                  v-model="progress"
                  color="#ff3700"
                  track-color="#ff3700"
                  :min="0"
                  :max="100"
                  label="Progress:"
                  :cancelable="false"
                >
                  <template #append>
                    <input
                      v-model="progress"
                      type="number"
                      class="v-slider-text-style"
                    >
                  </template>
                </v-slider>
                <div
                  v-if="showSaveBtn"
                  style="display: flex; align-items: end; justify-content: end"
                >
                  <v-btn
                    class="v-btn-style"
                    @click="saveProgress(progress)"
                  >
                    Update
                  </v-btn>
                  <v-btn
                    class="v-btn-style"
                    @click="restoreProgress"
                  >
                    Reset
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <br>
    <h3>Sub Tasks</h3>
    <div>
      <sub-jobs />
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import subJobs from './dialogComponents/JobsDialogs/SubJobs.vue';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
export default {
  name: 'JobDetailsPage',
  components: {
    'sub-jobs': subJobs,
    'centre-spinner': spinner,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('DD-MM-YYYY hh:mm A');
    },
  },
  data: () => ({
    tab: null,
    loading: false,
    progress: null,
    oldProgress: '',
    jobMoreDetails: null,
    showSaveBtn: false,
    panel: 0,
    statusList: [
      {
        title: 'ACTIVE',
        id: 'active',
      },
      {
        title: 'PENDING',
        id: 'pending',
      },
      {
        title: 'COMPLETED',
        id: 'completed',
      },
    ],
  }),
  computed: {
    jobDetails () {
      return this.$store.getters['jobs/getJobDetails'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    isSiteManager () {
      return this.selectedOrganization.app_user_role === 'site-manager';
    },
  },
  watch: {
    '$route.params.jobId': 'getJobDetails',
    progress (oldVal, newVal) {
      if (this.showSaveBtn === true && this.progress === this.oldProgress) {
        this.showSaveBtn = false;
        return;
      }
      if (
        Object.keys(this.jobDetails).length > 0 &&
        oldVal !== null &&
        newVal !== null
      ) {
        if (newVal < oldVal || newVal > oldVal) {
          this.showSaveBtn = true;
        }
      }
    },
  },
  async mounted () {
    await this.getJobDetails();
  },
  methods: {
    async getJobDetails () {
      this.loading = true;
      const jobId = this.$route.params.jobId;
      await this.$store
        .dispatch('jobs/fetchJobDetails', {
          jobId: jobId,
        })
        .then((response) => {
          this.progress = this.jobDetails.progress;
          this.oldProgress = this.jobDetails.progress;
          this.status = this.jobDetails.status;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getPriorityColor (priorty) {
      if (priorty === 'high') {
        return '#E67E22'; // Pumkin Orange
      } else if (priorty === 'low') {
        return '#2ECC71'; // Emerald Green
      } else if (priorty === 'medium') {
        return '#F1C40F'; // Golden Yellow
      } else {
        return '#C0392B'; // Dark red
      }
    },
    getStatusColor (val) {
      if (val === 'active') {
        return '#2ECC71';
      } else if (val === 'pending') {
        return '#FF9800 ';
      } else {
        return '#9E9E9E ';
      }
    },
    goBack () {
      this.$router.go(-1);
    },
    getStatusObject (item) {
      if (!item) return { id: '', title: '' };
      if (item.status && typeof item.status === 'object') return item.status;
      const found = this.statusList.find((s) => s.id === item.status);
      return (
        found || {
          id: item.status || '',
          title: String(item.status || '').toUpperCase(),
        }
      );
    },

    async changeStatus (item, statusObj) {
      this.$set(item, 'status', statusObj.id);
      await this.updateStatus(item, statusObj.id);
    },

    async updateStatus (item, statusValue) {
      this.loading = true;
      try {
        await this.$store.dispatch('jobs/saveProgress', {
          formData: {
            progress: this.jobDetails.progress,
            status: statusValue,
          },
          jobId: item.external_id,
        });
      } finally {
        this.loading = false;
      }
    },
    statusColor (val) {
      if (val === 'active') return 'green';
      if (val === 'pending') return 'orange';
      if (val === 'completed') return 'blue';
      return 'grey';
    },
    async saveProgress () {
      const jobId = this.$route.params.jobId;
      await this.$store.dispatch('jobs/saveProgress', {
        formData: {
          progress: String(this.progress),
          status: this.jobDetails.status,
        },
        jobId: jobId,
      });
      await this.getJobDetails();
      this.oldProgress = this.progress;
      this.showSaveBtn = false;
    },
    restoreProgress () {
      this.progress = this.oldProgress;
    },
  },
};
</script>

<style scoped>
.my-tabs-background-style {
  background-color: transparent;
}
.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}
.status-style {
  font-weight: bold;
  text-transform: capitalize;
}
.card-style {
  border-radius: 10px;
  margin-top: 20px;
}
.title-header-style {
  font-size: 20px;
  font-family: "Roboto", sans-serif;
  text-transform: capitalize;
}
.v-slider-text-style {
  width: 40px;
  height: 30px;
  border: 2px solid rgb(99, 99, 99);
  text-align: center;
}
.amount-text-style {
  color: green;
}
.chip-style {
  text-transform: capitalize;
}
.v-btn-style {
  font-size: 11px;
  margin-left: 15px;
}
.v-slider-style {
  color: #106996;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}
.status-activator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* chip size */
.status-activator .v-chip {
  height: 28px;
  font-size: 12px;
  line-height: 18px;
}

.status-activator .status-chevron {
  font-size: 25px !important;
  color: #e6e6e6; /* adjust as needed */
  opacity: 1;
}

/* compact menu items */
::v-deep(.status-menu .v-list-item) {
  min-height: 28px !important;
  padding: 4px 8px !important;
}

.text-format {
  text-transform: capitalize;
}
</style>
